import { useMemo } from 'react';
import useQueryParams from './useQueryParams';
import { FIRST_PAGE, PAGE_PARAM_KEYWORD } from 'data/global';

export default function usePageParams(pageParam = PAGE_PARAM_KEYWORD) {
  const { params } = useQueryParams();

  const page = useMemo(
    () => params?.[pageParam] || FIRST_PAGE,
    [pageParam, params],
  );

  return page;
}
